import script from "./school.vue?vue&type=script&setup=true&lang=js"
export * from "./school.vue?vue&type=script&setup=true&lang=js"

import "./school.vue?vue&type=style&index=0&id=e9f1cd50&lang=less"

import exportComponent from "/Users/lily/Documents/local/v-7pa-xling/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9f1cd50"]])

export default __exports__